import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { first, isUndefined, last } from 'lodash';
import { getEmojiFormattedSpan, ScaleLabels, ScaleSteps } from './utils';
import useOnInit from './hooks/useOnInit';

export default function Slider({ question, rtl }) {
  const { slideQuestionDto } = question || {};
  const inputName = 'slider';
  const {
    rangeStep: step = 1,
    minValue: min = 0,
    maxValue: max = 100,
    ticks = [],
  } = slideQuestionDto;
  const shouldShowScale = isUndefined(slideQuestionDto.shouldShowScale)
    ? true
    : slideQuestionDto.shouldShowScale;
  const shouldShowValue = slideQuestionDto.isRangeSelectionVisible
    ? true
    : slideQuestionDto.shouldShowValue;

  const sliderItems = ticks.sort((a, b) => a.tickValue - b.tickValue);

  const minLabel = getEmojiFormattedSpan(first(sliderItems).tickLabel);
  const maxLabel = getEmojiFormattedSpan(last(sliderItems).tickLabel);
  useOnInit({
    inputName,
    min,
    max,
    step,
    ticks,
    shouldShowScale,
    shouldShowValue,
    rtl,
  });

  return (
    <div id="sliderContainer">
      {shouldShowValue && (
        <div id="js-slider-value" className="ui-slider-value">
          0
        </div>
      )}
      {shouldShowScale && (
        <div className="scale">
          <div
            id="js-scale-container"
            className={classNames('scale-container', {
              'rtl-container': rtl,
            })}
          >
            <div className="scale-labels">
              <ScaleLabels sliderItems={sliderItems} />
            </div>
            <div className="scale-steps">
              <ScaleSteps min={min} max={max} step={step} />
            </div>
          </div>
        </div>
      )}
      <input
        id={inputName}
        value="0"
        min={min}
        max={max}
        step={step}
        readOnly
      />
      <div className="scale-container">
        <div className="scale-steps">
          <div className="scale-step sticky">|</div>
          <div className="scale-step sticky">|</div>
        </div>
        <div className="scale-labels">
          <div
            className="scale-label"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: minLabel }}
          />
          <div
            className="scale-label"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: maxLabel }}
          />
        </div>
      </div>
    </div>
  );
}

Slider.propTypes = {
  question: PropTypes.object,
  rtl: PropTypes.bool,
};
